import { getPlacementTask } from '@common/utils';
import { ActivityType, BoxTemplateLabels, FileType, PlacementTask } from 'enums';
import { useCompletePlacementTask } from 'hooks';
import { getFileMetadataField } from 'utils';
import { PostEmailInformation } from 'broker/components/EmailEditor/types';
import { useGetPlacementTaskEmailRecipients } from 'broker/hooks';
import { useFetchSubmissionFiles } from 'broker/pages/SubmissionWorkspacePage/hooks/useFetchSubmissionFiles';
import useSubmissionsWorkspace from 'broker/pages/SubmissionWorkspacePage/store/useSubmissionWorkspace';

export function useHandleSolicitationEmail() {
  const { partialSubmission, logSubmissionActivity } = useSubmissionsWorkspace();
  const solicitationPlacementTask = getPlacementTask(partialSubmission, PlacementTask.SendSolicitation);
  const { completePlacementTask } = useCompletePlacementTask();
  const { items: submissionFiles } = useFetchSubmissionFiles();

  const emailRecipientsConfig = solicitationPlacementTask?.stepConfig?.solicitationEmailRecipients;
  const solicitationRecipients = useGetPlacementTaskEmailRecipients(partialSubmission, emailRecipientsConfig);

  // The solicitation attachments are uploaded to Box with "Application Form" label when the placement task starts (handled by the lambda: handleSendSolicitation).
  // Here, we only need to filter submission files to select the application form files.
  const applicationFiles = submissionFiles.filter(
    (file) => getFileMetadataField(file, BoxTemplateLabels.FileType) === FileType.ApplicationForm,
  );
  const preSelectedFileIds = applicationFiles.map((file) => file.id);

  const handleSolicitationEmailSent = async (postEmailInformation?: PostEmailInformation) => {
    await logSubmissionActivity({ activityType: ActivityType.SolicitationEmailSent });

    if (partialSubmission) {
      const emailMessageId = postEmailInformation?.emailMessageIds?.[0];

      await completePlacementTask(partialSubmission, PlacementTask.SendSolicitation, {
        ...(emailMessageId && { metadata: { emailMessageId } }),
      });
    }
  };

  return {
    preSelectedFileIds,
    solicitationRecipients,
    handleSolicitationEmailSent,
  };
}
